<template>
    <div class="wrapper">
        <NavBar></NavBar><!--commonNav-->
        <router-view/>
        <Footer></Footer><!--end of footer-->
    </div><!--end of wrapper-->
</template>

<script>

    import NavBar from "@/components/NavBar";
    import Footer from "@/components/Footer";

    export default {
        name: 'Index',
        components: {
            NavBar,
            Footer
        }
    }
</script>
